import api, { authHeader } from '../API/apiConfig';

export const verifyEmail = (emailString) => {
  const validRegexEmail = /^[a-z0-9.!#$%&'*+/=?^_]+@[a-z0-9]+\.[a-z]/i;
  return validRegexEmail.test(emailString);
};

export async function downloadZipFolder({ name, id }) {
  await api
    .get(`uploads/folders/${id}/zipfile`, {
      headers: authHeader(),
      responseType: 'arraybuffer',
    })
    .then(({ data }) => {
      const url = window.URL.createObjectURL(
        new Blob([data], { type: 'application/zip' })
      );
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${name}.zip`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    });
}

export function orderArrayAlphabetically(array) {
  return array.sort((a, b) => {
    const nameA = a.name.toUpperCase();
    const nameB = b.name.toUpperCase();
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
    return 0;
  });
}

export function formatCPF(value) {
  const formattedValue = value.replace(/[^\d]/g, '');
  return formattedValue.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
}

export function formatCNPJ(value) {
  const formattedValue = value.replace(/[^\d]/g, '');
  return formattedValue.replace(
    /^(\d{2})(\d{3})?(\d{3})?(\d{4})?(\d{2})?/,
    '$1 $2 $3/$4-$5'
  );
}
